import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Section } from '../types/section.type';
import { MenuOptions } from '../types/footer-options.type';

/**
 * Builder Service
 *
 * @export
 * @class Global
 */
@Injectable({ providedIn: 'root' })
export class LayoutBuilderService {
    /**
     * Header Area Sections
     */
    private _headerAreaSections = new BehaviorSubject<Section[]>([]);

    /**
     * Footer Area Sections
     */
    private _footerAreaSections = new BehaviorSubject<Section[]>([]);

    /**
     * Site Menus
     */
    private _siteMenus = new BehaviorSubject<MenuOptions[]>([]);

    /**
     * Set layout sections
     */
    set layoutSections(sections: Section[]) {
        let placeholderIndex = sections.findIndex(
            (section) => section.options.type === 'placeholder',
        );

        // Store everything above the placeholder as headerAreaSections
        if (placeholderIndex !== -1) {
            this._headerAreaSections.next(sections.slice(0, placeholderIndex));
        }

        // Store everything below the placeholder as footerAreaComponents
        this._footerAreaSections.next(sections.slice(placeholderIndex + 1));
    }

    /**
     * Set Site Menus
     */
    set siteMenus(menus: MenuOptions[]) {
        this._siteMenus.next(menus);
    }

    /**
     * Get header area sections
     */
    get headerAreaSections(): Observable<Section[]> {
        return this._headerAreaSections.asObservable();
    }

    /**
     * Get footer area sections
     */
    get footerAreaSections(): Observable<Section[]> {
        return this._footerAreaSections.asObservable();
    }

    /**
     * Get footer area sections
     */
    get footerAreaSectionsValue(): Section[] {
        return this._footerAreaSections.value;
    }

    get siteMenus(): Observable<MenuOptions[]> {
        return this._siteMenus.asObservable();
    }
}
